import configuratorManualFeHtml from './configuratorManualFe.html';
import configuratorManualFeModalAddProductHtml from './modalsFe/configuratorManualFeModalAddProduct.html';
import configuratorManualFeModalAddProductController from './modalsFe/configuratorManualFeModalAddProduct.controller';
import configuratorManualFeModalEditProductHtml from './modalsFe/configuratorManualFeModalEditProduct.html';
import configuratorManualFeModalEditProductController from './modalsFe/configuratorManualFeModalEditProduct.controller';
import configuratorManualFeModalDeleteProductHtml from './modalsFe/configuratorManualFeModalDeleteProduct.html';
import configuratorManualFeModalDeleteProductController from './modalsFe/configuratorManualFeModalDeleteProduct.controller';
import configuratorManualFeModalEditProductProjectFileHtml from './modalsFe/configuratorManualFeModalEditProductProjectFile.html';
import configuratorManualFeModalEditProductProjectFileController from './modalsFe/configuratorManualFeModalEditProductProjectFile.controller';
import configuratorManualFeModalEditProductNameHtml from './modalsFe/configuratorManualFeModaEditProductName.html';
import configuratorManualFeModalEditProductNameController from './modalsFe/configuratorManualFeModalEditProductName.controller';
import './configuratorManualFe.scss';
import downloadOfferHtml from './downloadOffer.modal.html';
import downloadOfferController from './downloadOffer.controller';
import './downloadOffer.modal.scss';

class configuratorManualFeController {
    constructor($scope, $timeout, $http, ModalService, cartService, translateService, priceTypeService) {
        'ngInject';

        this.$timeout = $timeout;
        this.$http = $http;
        this.modalService = ModalService;
        this.cartService = cartService;
        this.translate = translateService;

        this.threadId = false;
        this.submissionDate = new Date().toISOString().split('T')[0];
        this.userName = '';
        this.localUserName = '';
        this.editingUserName = false;
        this.totalCostPricedProducts = null;
        this.materials = [];
        this.threadOrderStatuses = [];
        this.products = [];
        this.currentTimestamp = Math.floor(Date.now() / 1000);
        this.priceType = priceTypeService;
        this.message = '';
        this.downloadOfferModal = null;
        this.loaded = false;
        this.saving = false;
        this.error = false;
        this.success = false;

        this.lastMaterialId = null;
        this.lastMaterialSubtypeId = null;
        this.lastMaterialSizeId = null;

        this.loadMaterials();

        this.loadThreadOrderStatuses();

        $scope.$watch(() => this.threadId, (newVal, oldVal) => {
            if (newVal === null) {
                $timeout(() => {
                    this.loaded = true;
                }, 500);

                return;
            }

            this.loadThreadSubmissionDate();

            this.loadThreadUserName();

            this.loadThreadTotalCostPricedProducts();

            this.loadProducts();
        });
    }

    get shopPaymentCountries() {
        return window.shopPaymentCountries;
    }

    get shopId() {
        return window.shopId;
    }

    get isDev() {
        return window.tmpIsDev;
    }

    get aLogged() {
        return window.tmpALogged;
    }

    loadThreadSubmissionDate() {
        this.$http.get(
            `/user/configurator/manual/ajax/getSubmissionDate/${this.threadId}`
        ).then(
            (response) => {
                this.submissionDate = response.data.submissionDate;
            },
            () => {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
            }
        );
    }

    loadThreadUserName() {
        this.$http.get(
            `/user/configurator/manual/ajax/getUserName/${this.threadId}`
        ).then(
            (response) => {
                this.userName = response.data.userName;
            },
            () => {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
            }
        );
    }

    loadThreadTotalCostPricedProducts() {
        this.$http.get(
            `/user/configurator/manual/ajax/getTotalCostPricedProducts/${this.threadId}`
        ).then(
            (response) => {
                this.totalCostPricedProducts = response.data.totalCostPricedProducts;
            },
            () => {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
            }
        );
    }

    loadMaterials() {
        this.$http.get(
            `/user/configurator/manual/ajax/getMaterials`
        ).then((response) => {
            for (let material of response.data) {
                material.available = true;
                material.image = material.image.src || null;
            }
            this.materials = response.data;
        });
    }

    loadThreadOrderStatuses() {
        this.$http.get(
            `/user/configurator/manual/ajax/getThreadOrderStatuses`
        ).then(
            (response) => {
                this.threadOrderStatuses = response.data;
            },
            () => {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
            }
        );
    }

    loadProducts() {
        this.$http.get(
            `/user/configurator/manual/ajax/getProducts/${this.threadId}`
        ).then(
            (response) => {
                this.loaded = true;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.deliveryDate = response.data.delivery_date;
                    this.products = response.data.products;
                    // this.products = this.products.map((product, index) => {
                    //     if (!product.product_name) {
                    //         product.product_name = this.getProductName(product, index);
                    //     }

                    //     if (!product.user_product_name) {
                    //         product.user_product_name = product.product_name;
                    //     }

                    //     return product;
                    // });
                    this.setProductsFiles();
                }
            },
            () => {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
            }
        );
    }

    setProductsFiles() {
        for (const product of this.products) {
            if (product.file_name) {
                product.productionFile = atob(product.file_name.data);
                product.productionFileExtension = product.file_name.extension;
            }
        }
    }

    editUserName() {
        this.editingUserName = true;
        this.localUserName = this.userName;
    }

    cancelUserName() {
        this.editingUserName = false;
        this.localUserName = this.userName;
    }

    saveUserName() {
        this.editingUserName = false;
        this.userName = this.localUserName;

        if (!(this.threadId === null || this.threadId === false)) {
            this.$http.post('/user/configurator/manual/ajax/saveThreadName', {thread_id: this.threadId, thread_user_name: this.userName}, {
                headers: {'Content-Type': 'application/json'}
            }).then(
                (response) => {
                    if (response.data.status === 'error') {
                        this.error = response.data.message;

                        this.$timeout(() => {
                            this.error = false;
                        }, 5000);
                    }
                },
                () => {
                    alert(_this.translate.t('configuratorManual.errors.unexpected'));
                }
            );
        }
    }

    extendUserProductName(product) {
        let productName = [];

        if (product.width !== null && product.height !== null) {
            productName.push(`${product.width} mm * ${product.height} mm`);
        } else {
            productName.push('0 mm * 0 mm');
        }

        productName.push(product.material.name);

        if (product.material_subtype !== null) {
            productName.push(product.material_subtype.name);
        }

        productName.push(product.material_size.name);

        switch (product.cut_mode) {
            case 'chain':
                productName.push(this.translate.t('configurator.cutMode.chain.mobile'));
                break;
            case 'chainPolished':
                productName.push(this.translate.t('configurator.cutMode.chainPolished.mobile'));
                break;
            case 'laser':
                productName.push(this.translate.t('configurator.cutMode.laser.mobile'));
                break;
            case 'frez':
                productName.push(this.translate.t('configurator.cutMode.frez.mobile'));
                break;
        }

        return product.user_product_name + ' (' + productName.join(', ') + ')';
    }

    addProduct() {
        let materials = this.materials;

        if (this.products.length >= 50) {
            this.error = this.translate.t('configuratorManual.errors.maximumProductLimit', {limit: 50});

            return;
        }

        this.modalService.showModal({
            template: configuratorManualFeModalAddProductHtml,
            controller: configuratorManualFeModalAddProductController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            },
            inputs: {
                materials: materials,
                lastMaterialId: this.lastMaterialId,
                lastMaterialSubtypeId: this.lastMaterialSubtypeId,
                lastMaterialSizeId: this.lastMaterialSizeId
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(result => {
                if (result !== false) {
                    let newProduct = {
                        id: null,
                        letter_id: null,
                        status: 0,
                        suggested_price_net: null,
                        suggested_price_gros: null,
                        width: null,
                        height: null,
                        depth: null,
                        material: result.material,
                        material_id: result.material !== null ? result.material.id : null,
                        material_subtype: result.material_subtype,
                        material_subtype_id: result.material_subtype !== null ? result.material_subtype.id : null,
                        material_size: result.material_size,
                        material_size_id: result.material_size !== null ? result.material_size.id : null,
                        cut_mode: '',
                        thickness: 1.19,
                        quantity: result.quantity,
                        user_file_name: result.file,
                        user_product_name: result.user_product_name,
                        user_product_name_without_suffix: '',
                        suffix_for_user_product_name: '',
                        file_name: null,
                        offered_at: null,
                        created_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
                        new_product: true
                    };

                    if (typeof newProduct.user_product_name !== 'undefined' && newProduct.user_product_name !== null && newProduct.user_product_name !== '') {
                        newProduct.user_product_name = this.extendUserProductName(newProduct);
                    }

                    this.products.push(newProduct);

                    this.lastMaterialId = newProduct.material_id;
                    this.lastMaterialSubtypeId = newProduct.material_subtype_id;
                    this.lastMaterialSizeId = newProduct.material_size_id;
                }
            });
        });
    }

    editProduct(index) {
        let currentProduct = this.products[index];
        let currentProductLetterId = this.getProductId(index);
        let materials = this.materials;

        this.modalService.showModal({
            template: configuratorManualFeModalEditProductHtml,
            controller: configuratorManualFeModalEditProductController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            },
            inputs: {
                materials: materials,
                product: {
                    material: currentProduct.material,
                    material_subtype: currentProduct.material_subtype,
                    material_size: currentProduct.material_size,
                    quantity: currentProduct.quantity,
                    file: currentProduct.user_file_name,
                    user_product_name: currentProduct.user_product_name
                },
                product_letter_id: currentProductLetterId
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(result => {
                if (result !== false) {
                    this.products[index].material = result.material;
                    this.products[index].material_id = result.material !== null ? result.material.id : null;
                    this.products[index].material_subtype = result.material_subtype;
                    this.products[index].material_subtype_id = result.material_subtype !== null ? result.material_subtype.id : null;
                    this.products[index].material_size = result.material_size;
                    this.products[index].material_size_id = result.material_size !== null ? result.material_size.id : null;
                    this.products[index].quantity = result.quantity;
                    this.products[index].user_file_name = result.file;
                    this.products[index].user_product_name = result.user_product_name;

                    if (typeof this.products[index].user_product_name !== 'undefined' && this.products[index].user_product_name !== null && this.products[index].user_product_name !== '') {
                        this.products[index].user_product_name = this.extendUserProductName(this.products[index]);
                    }
                }
            });
        });
    }

    deleteProduct(index) {
        let currentProductLetterId = this.getProductId(index);

        this.modalService.showModal({
            template: configuratorManualFeModalDeleteProductHtml,
            controller: configuratorManualFeModalDeleteProductController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            },
            inputs: {
                product_letter_id: currentProductLetterId
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(result => {
                if (result !== false) {
                    this.products.splice(index, 1);
                }
            });
        });
    }

    decreaseProductQuantity(index) {
        let currentProduct = this.products[index];
        if (currentProduct.quantity > 1) {
            currentProduct.quantity--;

            this.changeProductQuantity(index);
        }
    }

    increaseProductQuantity(index) {
        let currentProduct = this.products[index];
        currentProduct.quantity++

        this.changeProductQuantity(index);
    }

    changeProductQuantity(index) {
        let currentProduct = this.products[index];
        if (currentProduct.quantity < 1) {
            currentProduct.quantity = 1;
        }

        if (currentProduct.new_product) {
            return;
        }

        this.downloadOfferModal = null;

        this.$http.post('/user/configurator/manual/ajax/changeProductQuantity', {
            thread_id: this.threadId,
            order_id: currentProduct.id,
            quantity: currentProduct.quantity
        }, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.saving = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else if (response.data.status === 'warning') {
                    this.products[index] = response.data.product;
                    this.setProductsFiles();
                    this.totalCostPricedProducts = response.data.totalCostPricedProducts;

                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.products[index] = response.data.product;
                    this.setProductsFiles();
                    this.totalCostPricedProducts = response.data.totalCostPricedProducts;
                }
            },
            () => {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
                this.saving = false;
            }
        );
    }

    editProductProjectFile(index) {
        let currentProduct = this.products[index];
        let currentProductLetterId = this.getProductId(index);

        this.modalService.showModal({
            template: configuratorManualFeModalEditProductProjectFileHtml,
            controller: configuratorManualFeModalEditProductProjectFileController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            },
            inputs: {
                file: currentProduct.user_file_name,
                product_letter_id: currentProductLetterId
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(result => {
                if (result !== false) {
                    this.products[index].user_file_name = result;

                    const form = new FormData();

                    form.append('product_id', this.products[index].id);
                    form.append('file', result.fileFormData.get('file'));

                    this.$http.post('/user/configurator/manual/ajax/changeProductProjectFile', form, {
                        transformRequest: angular.identity,
                        headers: {'Content-Type': undefined}
                    }).then(
                        (response) => {
                            this.saving = false;
                            if (response.data.status === 'error') {
                                this.error = response.data.message;

                                this.$timeout(() => {
                                    this.error = false;
                                }, 5000);
                            }
                        },
                        () => {
                            alert(this.translate.t('configuratorManual.errors.unexpected'));
                            this.saving = false;
                        }
                    );
                }
            });
        });
    }

    addToCart(index) {
        let currentProduct = this.products[index];
        let currentProductLetterId = this.getProductId(index);

        if (currentProduct.new_product === false && ((currentProduct.status === 3 && currentProduct.suggested_price_net !== null) || currentProduct.status === 1)) {
            this.$http.post('/user/configurator/manual/ajax/addToCart', {thread_id: this.threadId, order_id: currentProduct.id}, {
                headers: {'Content-Type': 'application/json'}
            }).then(
                (response) => {
                    this.saving = false;
                    if (response.data.status === 'error') {
                        this.error = response.data.message;

                        this.$timeout(() => {
                            this.error = false;
                        }, 5000);
                    } else {
                        currentProduct.status = 1;

                        this.cartService.load();

                        let cartUrl = this.translate.t('checkout.routes.cart');
                        this.success = this.translate.t('configuratorManual.productAddedToCart', {
                            product: currentProductLetterId,
                            cartUrl: '/' + cartUrl
                        });

                        this.$timeout(() => {
                            this.success = false;
                        }, 5000);
                    }
                },
                () => {
                    alert(this.translate.t('configuratorManual.errors.unexpected'));
                    this.saving = false;
                }
            );
        } else {
            this.error = this.translate.t('configuratorManual.errors.waitForPricing', {product: currentProductLetterId});

            this.$timeout(() => {
                this.error = false;
            }, 5000);
        }
    }

    addThreadToCart() {
        this.$http.post('/user/configurator/manual/ajax/addThreadToCart', {thread_id: this.threadId}, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.saving = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.cartService.load();

                    let cartUrl = this.translate.t('checkout.routes.cart');
                    this.success = this.translate.t('configuratorManual.productsAddedToCart', {cartUrl: '/' + cartUrl});

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);
                }
            },
            () => {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
                this.saving = false;
            }
        );
    }

    getProductId(index) {
        if (index <= 25) {
            return String.fromCharCode('A'.charCodeAt() + index);
        } else {
            let prefix = Math.floor(index / 25);
            index = index - (25 * prefix) - 1;

            return String.fromCharCode('A'.charCodeAt() + index) + prefix;
        }
    }

    saveToUserProducts(product) {
        this.saving = true;

        const form = new FormData();
        form.append('product_id', product.id);

        this.$http.post('/user/configurator/manual/ajax/saveToUserProducts', form, {
            headers: {'Content-Type': undefined}
        }).then(response => {
            if (response.data.status === 'success') {
                this.success = this.translate.t('configuratorManual.productSavedToMyProducts');
                this.$timeout(() => {
                    this.success = false;
                }, 5000);
            } else {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
            }
            this.saving = false;
        }, () => {
            alert(this.translate.t('configuratorManual.errors.unexpected'));
            this.saving = false;
        });
    }

    editUserProductName(product) {
        this.modalService.showModal({
            template: configuratorManualFeModalEditProductNameHtml,
            controller: configuratorManualFeModalEditProductNameController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            },
            inputs: {
                product: product
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(result => {
                if (result !== false) {
                    this.saveUserProductName(result.product, result.user_product_name_without_suffix);
                }
            });
        });
    }

    saveUserProductName(product, user_product_name_without_suffix) {
        this.saving = true;

        const form = new FormData();
        form.append('product_id', product.id);
        form.append('user_product_name', user_product_name_without_suffix);

        this.$http.post('/user/configurator/manual/ajax/saveUserProductName', form, {
            headers: {'Content-Type': undefined}
        }).then(response => {
            if (response.data.status === 'success') {
                product.user_product_name = response.data.user_product_name;
                product.user_product_name_without_suffix = response.data.user_product_name_without_suffix;
                product.suffix_for_user_product_name = response.data.suffix_for_user_product_name;
                this.success = this.translate.t('configuratorManual.productNameSaved');
                this.$timeout(() => {
                    this.success = false;
                }, 5000);
            } else {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
            }
            this.saving = false;
        }, () => {
            alert(this.translate.t('configuratorManual.errors.unexpected'));
            this.saving = false;
        });
    }

    getProductName(product, $index) {
        console.log('--- start ---');
        console.log(product.user_product_name);
        console.log(product.product_name);
        console.log(product.suffix_for_user_product_name);

        if (product.user_product_name !== '' && product.user_product_name !== null) {
            return '<strong>' + product.user_product_name_without_suffix + '</strong> (' + product.suffix_for_user_product_name + ')';
        }

        if (product.product_name !== '' && product.product_name !== null) {
            return product.product_name;
        }

        let productName = [];

        productName.push(this.translate.t('admpanel.manualConfigurator.productFromManualConfigurator', {index: this.getProductId($index)}));

        console.log(productName);

        if (this.threadId) {
            productName.push('#' + this.threadId);
        }

        if (product.status !== 0 && product.width !== null && product.height !== null) {
            productName.push(`${parseInt(product.width)} mm * ${parseInt(product.height)} mm`);
        }

        productName.push(product.material.name);

        if (product.material_subtype !== null) {
            productName.push(product.material_subtype.name);
        }

        productName.push(product.material_size.name);

        switch (product.cut_mode) {
            case 'chain':
                productName.push(this.translate.t('configurator.cutMode.chain.mobile'));
                break;
            case 'chainPolished':
                productName.push(this.translate.t('configurator.cutMode.chainPolished.mobile'));
                break;
            case 'laser':
                productName.push(this.translate.t('configurator.cutMode.laser.mobile'));
                break;
            case 'frez':
                productName.push(this.translate.t('configurator.cutMode.frez.mobile'));
                break;
        }

        console.log(productName);

        console.log('--- end ---');
        return productName.join(', ');
    }

    getUserFileName(userFileName) {
        if (userFileName !== null) {
            let tmpUserFileName = userFileName.fileName;

            const regex = /([0-9]{0,})_([0-9]{0,})_(.*)_([0-9]{4})_([0-9]{2})_([0-9]{2})_([0-9]{2})_([0-9]{2})_([0-9]{2})\.([a-zA-Z]{2,4})/;
            const matches = tmpUserFileName.match(regex);
            if (matches && matches.length >= 11) {
                tmpUserFileName = matches[3] + '.' + matches[10];
                tmpUserFileName = tmpUserFileName.replace(new RegExp(userFileName.extension + '.' + userFileName.extension + "*$"), '.' + userFileName.extension);
            }

            return tmpUserFileName;
        }

        return null;
    }

    scrollToConversation() {
        let conversationElement = document.getElementById('conversation');
        let htmlElement = document.getElementsByTagName('html')[0];
        htmlElement.scrollTop = conversationElement.getBoundingClientRect().top + htmlElement.scrollTop - 100;
    }

    save() {
        if (this.products.length < 1) return;
        this.saving = true;

        const form = new FormData();

        for (const product of this.products) {
            const {user_file_name, ...data} = product;

            form.append('products[]', JSON.stringify(data));

            if (user_file_name) {
                form.append('files[]', user_file_name.fileFormData.get('file'));
            } else {
                form.append('files[]', '-');
            }
        }

        form.append('message', this.message);
        form.append('user_name', this.userName);

        this.$http.post('/user/configurator/manual/ajax/saveNewThread', form, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                this.saving = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    window.location.pathname = 'user/configurator/manual/thread/' + response.data.id;
                }
            },
            () => {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
                this.saving = false;
            }
        );
    }

    downloadOffer() {
        if (this.downloadOfferModal) {
            this.downloadOfferModal.element.modal('show');
            return true;
        }

        const threadId = this.threadId;
        let countries = this.shopPaymentCountries;

        this.modalService.showModal({
            template: downloadOfferHtml,
            controller: downloadOfferController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            },
            inputs: {
                shipmentId: 4,
                threadId: threadId,
                countries: countries,
                hide: () => {
                    this.downloadOfferModal.element.modal('hide');
                }
            }
        }).then(modal => {
            this.downloadOfferModal = modal;

            this.downloadOfferModal.element.modal('hide');
    
            this.downloadOfferModal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
        });

        return true;
    }
}

let configuratorManualFeComponent = {
    bindings: {
        'threadId': '<'
    },
    template: configuratorManualFeHtml,
    controller: configuratorManualFeController
};

export default configuratorManualFeComponent;
